'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var StatusCheckLinear = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsx(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12.663 4.627c.38.36.39.964.02 1.336l-5.444 5.464a1 1 0 0 1-1.358 0L3.34 8.962a.932.932 0 1 1 1.3-1.336L6.56 9.5l4.799-4.852a.933.933 0 0 1 1.304-.021",
            clipRule: "evenodd"
        })
    }));
});
StatusCheckLinear.displayName = "StatusCheckLinear";

export { StatusCheckLinear, StatusCheckLinear as default };
